/* eslint-disable react/prop-types */
import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import * as Sentry from "@sentry/react";
import Appointment from "../../services/api/appointment";
import Button from "../common/Button";
import { CommonStyles } from "../common/Button/commonButtonStyle";
import Modal from "../common/Modal/Modal";
import InputField from "../common/new/InputField/InputField";
import styles from "./styles";
import { AlertStatus } from "../../contants";

function RejectAppointmentApplication({
  application,
  open,
  onClose,
  onBack,
  toast,
}) {
  const [remark, setRemark] = useState("");

  const onReject = async () => {
    try {
      const body = {
        data: {
          message: remark,
        },
      };
      await Appointment.rejectAppointment(
        body,
        application.memberDetails.memberId,
        application.id
      );
      toast.show("Rejected Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        onClose();
        onBack();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div>
        {/* <Formik> */}
        <Box style={{ paddingBottom: "5px" }}>
          <Typography
            style={{
              color: "#8C8C8C",
              fontSize: "20px ",
              fontWeight: "500",
            }}
          >
            Reject Appointment Application
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flex-end"
          padding="15px 0px 15px 0px"
        />
        <div>
          <InputField
            // variant="outlined"
            type="text"
            defaultValue=""
            key="remark"
            name="remark"
            label="Enter your remark here..."
            style={styles.inputStyle}
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            InputProps={{ sx: { minHeight: "91px" } }}
          />
        </div>
        <div style={{ display: "flex", gap: 50 }}>
          <Button
            variant="contained"
            style={CommonStyles.buttonStyle}
            onClick={() => {
              if (!remark) {
                toast.show("Remarks should not be empty!", AlertStatus.ERROR);
              } else {
                onReject();
              }
            }}
            type="submit"
            label="REJECT"
          />
          <Button
            variant="outlined"
            style={{
              ...CommonStyles.buttonStyle,
            }}
            onClick={onClose}
            label="CANCEL"
          />
        </div>
      </div>
    </Modal>
  );
}

export default RejectAppointmentApplication;
